/**
 * Marks a popup of the editor (rendered in a portal, outside the field): focus
 * moving into it does not leave the field, e.g. a collapsible comment keeps its
 * toolbar open while a colour is picked.
 */
export const RICH_TEXT_POPUP_ATTRIBUTE = 'data-rich-text-popup';

export function isInsideRichTextPopup(node: EventTarget | null): boolean {
  return node instanceof Element && Boolean(node.closest(`[${RICH_TEXT_POPUP_ATTRIBUTE}]`));
}
